import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    AlertDialogPortal,
    AlertDialogTitle,
    AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { useState } from "react";
import TCSEditForm from "./TCSEditForm";
import TCSWarning from "./TCSEditWarning";
import { FormProvider, useForm } from "react-hook-form";
import { TCSFormData } from "pages/GenericOrderDetailsPage/types";
import { useTCSEdit } from "pages/GenericOrderDetailsPage/hooks/useTCSEdit";
import { Spinner } from "components";
export default function TCSEditDialog({ tcs, id, displayName }: {
    tcs: number | string;
    id: string;
    displayName: string;
}) {
    const [isTCSEditing, setIsTCSEditing] = useState(false);
    const methods = useForm<TCSFormData>({
        mode: 'onChange'
    });
    const {updateTCS, loading} = useTCSEdit()
    const handleTCSCancel = () => {
        setIsTCSEditing(false);
        methods.reset();
    }
    const tcsValue = methods.watch('tcsValue');
    const isChecked = methods.watch('isChecked');

    const handleTCSSave = async (data: TCSFormData) => {
        updateTCS({
            tcs_amount:Number(data.tcsValue),
            order_id: id
        });
        setIsTCSEditing(false);
        methods.reset();
    }    
    return (
        <AlertDialog open={isTCSEditing} onOpenChange={setIsTCSEditing}>
            <AlertDialogTrigger asChild>
                <button
                    className=""
                    onClick={() => setIsTCSEditing(true)}
                >
                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.42969 4.46094H2.59635C2.15433 4.46094 1.7304 4.63653 1.41784 4.94909C1.10528 5.26165 0.929688 5.68558 0.929688 6.1276V13.6276C0.929688 14.0696 1.10528 14.4936 1.41784 14.8061C1.7304 15.1187 2.15433 15.2943 2.59635 15.2943H10.0964C10.5384 15.2943 10.9623 15.1187 11.2749 14.8061C11.5874 14.4936 11.763 14.0696 11.763 13.6276V12.7943" stroke="#165FE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.9271 2.79957L13.4271 5.29957M14.5813 4.1204C14.9095 3.7922 15.0938 3.34705 15.0938 2.8829C15.0938 2.41875 14.9095 1.97361 14.5813 1.6454C14.253 1.3172 13.8079 1.13281 13.3437 1.13281C12.8796 1.13281 12.4345 1.3172 12.1063 1.6454L5.09375 8.6329V11.1329H7.59375L14.5813 4.1204Z" stroke="#165FE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                </button>
            </AlertDialogTrigger>
            <AlertDialogPortal>
                {
                    loading && <Spinner />
                }
                <AlertDialogOverlay className=" bg-black-900 bg-opacity-60 animate-overlayShow fixed inset-0" />
                <AlertDialogContent className="bg-white-A700 rounded-lg p-0 max-w-md animate-contentShow">
                    <form className="max-w-md">
                    
                        <AlertDialogHeader className="flex text-left gap-4 pt-8 pb-4 px-10 ">
                            <AlertDialogTitle className="font-bold text-xl leading-7 tracking-[2%] text-black-label">
                                Edit TCS charges
                            </AlertDialogTitle>
                            <div className="border-b-2 border-gray-300 my-2 w-full"></div>
                            <FormProvider {...methods}>
                                <TCSEditForm
                                    displayName={displayName}
                                    currentTCS={tcs as number}
                                />
                            </FormProvider>
                        </AlertDialogHeader>
                        <AlertDialogFooter className="flex justify-end items-center gap-2.5 py-5 px-10 flex-row rounded-b-lg bg-gray-button-gray-lite">
                            <AlertDialogCancel
                                className=" m-0 rounded-lg border-blue-700 border py-[11px] px-4 text-blue-700"
                                asChild
                            >
                                <button onClick={handleTCSCancel}>Close</button>
                            </AlertDialogCancel>
                            {(tcs as number || 0) > parseInt(tcsValue) ? (
                                <TCSWarning
                                    tcs_amount={tcs as number}
                                    order_id={id}
                                    tcsValue={tcsValue}
                                    handleSubmit={() => {
                                        methods.handleSubmit((data) => {
                                            handleTCSSave(data)
                                        })()
                                    }}
                                >
                                    <AlertDialogAction
                                        className={`rounded-lg border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700 ${!isChecked ? "opacity-50 cursor-not-allowed" : ""
                                            }`}
                                    >
                                        Save
                                    </AlertDialogAction>
                                </TCSWarning>
                            ) : (
                                <AlertDialogAction
                                    type="submit"
                                    onClick={methods.handleSubmit((data) => {
                                        handleTCSSave(data)
                                    })}
                                    className={`rounded-lg border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700 ${!isChecked ? "opacity-50 cursor-not-allowed" : ""
                                        }`}
                                    disabled={!isChecked || !tcsValue}
                                >
                                    Save
                                </AlertDialogAction>
                            )}
                        </AlertDialogFooter>
                    </form>
                </AlertDialogContent>
            </AlertDialogPortal>
        </AlertDialog>
    )
}